Librarian.Modules.MyUploads = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-myuploads-",
        label: null,
        pageName: "My Workspace",
        isMooTree: false
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl) {
            return;
        }

        this.parent();
        var self = this;
        this.wrapperEl.addClass("nav-wrapper");

        if(this.options.isMooTree) {
            // open browse part of moo tree to myUploads
            this.wrapperEl.addEvent("click", function() {
                $("library").click();
                Library.myUploadClick(false);
            });
        } else {
            this.wrapperEl.addEvent("click", function() {
                Library.loadTabByName(self.options.pageName);
                Library.myUploadClick(false);
            });
        }
        
        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }
});